import React from 'react';
import styled from '@benzinga/themetron';
import { Podcast } from '@benzinga/content-manager';
import { Button, SectionTitle } from '@benzinga/core-ui';
import { MediaCard } from '@benzinga/ui';
import { DateTime } from 'luxon';
import { convertToRelativeUrl } from '@benzinga/utils';

interface PodcastsListProps {
  podcasts?: Podcast[];
  attrs?: {
    data?: {
      title?: string;
    };
  };
}

export const PodcastsListBlock: React.FC<PodcastsListProps> = ({ attrs, podcasts }) => {
  const title = attrs?.data?.title;

  if (!Array.isArray(podcasts)) return null;

  return (
    <PodcastsListWrapper>
      {title && <SectionTitle className="podcasts-title">{title || 'Podcasts'}</SectionTitle>}
      {Array.isArray(podcasts) &&
        podcasts.map((podcast: Podcast, i: number) => {
          const date = podcast.date ? DateTime.fromJSDate(new Date(podcast.date)).toFormat('MMM dd, yyyy') : null;
          const link = convertToRelativeUrl(podcast.podcast_page_link);
          return (
            <MediaCard
              contentId="Podcasts"
              image={podcast.image}
              key={i}
              link={link}
              subtitle={date}
              title={podcast.title}
            />
          );
        })}
      {/* eslint-disable-next-line react/jsx-no-target-blank */}
      <a
        className="podcast-footer"
        data-action="Browse All Podcasts Footer Button Click"
        href="https://www.benzinga.com/podcasts"
        target="_blank"
      >
        <Button className="see-all-button" variant="primary">
          <span>Browse All Podcasts</span>
        </Button>
      </a>
    </PodcastsListWrapper>
  );
};

export const PodcastsListWrapper = styled.div`
  display: grid;
  margin: 1rem 0;
  gap: 8px;
  .podcast-footer {
    width: 100%;
  }
  .see-all-button {
    justify-content: center;
    width: 100%;

    > span {
      font-weight: bold;
      text-transform: uppercase;
    }
  }
  .media-card {
    .title-date-wrapper {
      min-height: 120px;
    }
    .image-wrapper {
      width: 120px;
      min-height: 120px;
      min-width: 120px;
      max-width: 120px;
    }
  }
`;
